import { isNil } from 'lodash'
import { DateTime } from 'luxon'

import { DatePickerDropdownValue, DateType } from './types'

/** Day-granular equality (local zone, year/month/day). */
function sameDay(day1: Date, day2: Date): boolean {
  return DateTime.fromJSDate(day1).hasSame(DateTime.fromJSDate(day2), 'day')
}

export const allDropDownOptions: DatePickerDropdownValue[] = [
  'custom',
  'singleDay',
  'noStart',
  'noEnd',
  'thisMonth',
  'lastMonth',
]

/**
 * Returns true if potentially undefined or null dates are the same
 */
export function isDateMatch(day1: DateType, day2: DateType) {
  if (isNil(day1) && isNil(day2)) return true
  else if (!day1 || !day2) return false
  else return sameDay(day1, day2)
}

/**
 * Returns the last day of the previous month as a new date
 */
export function getPreviousMonthDate(date: Date) {
  return DateTime.fromJSDate(date).startOf('month').minus({ days: 1 }).toJSDate()
}

/**
 * Returns first day of provided month as a new date
 */
export function firstOfMonth(date: Date) {
  return DateTime.fromJSDate(date).startOf('month').toJSDate()
}

/**
 * Returns true if date range covers first of this month through today
 */
export function isThisMonth(from: Date, to: Date) {
  const endDate = new Date()
  const startDate = firstOfMonth(endDate)
  return sameDay(startDate, from) && sameDay(endDate, to)
}

/**
 * Returns true if date range covers all of last month
 */
export function isLastMonth(from: Date, to: Date) {
  const today = new Date()
  const endDate = getPreviousMonthDate(today)
  const startDate = firstOfMonth(endDate)
  return sameDay(startDate, from) && sameDay(endDate, to)
}

export function getDateRangeInDays(from: Date, to: Date) {
  return DateTime.fromJSDate(to).diff(DateTime.fromJSDate(from), 'days').days
}
